// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__yd+su","inputSearch":"Search_inputSearch__xgA5i"};